import { cn } from '@/lib/cn';

/**
 * הפסים האלכסוניים הם הסימן המזוהה של המותג, ולכן מופיעים
 * רק בשלושה מקומות: מסך הכניסה, "הכר את המוצר", ומצטייני החודש.
 * אף פעם לא מאחורי טקסט רץ.
 */
export function StripeBand({
  tone = 'surface',
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & { tone?: 'surface' | 'sign' }) {
  return (
    <div
      aria-hidden="true"
      className={cn('h-14 w-full', tone === 'sign' ? 'stripes-sign' : 'stripes', className)}
      {...props}
    />
  );
}
